import { Subject } from 'rxjs';

export class CartUpdateService {
  // Create a new Subject to emit cart update events
  static cartUpdated = new Subject();

  // Emit the cart updated event
  static updateCart(data) {
    CartUpdateService.cartUpdated.next(data);
  }
}
